"use client";

/**
 * System avatar for AI chat messages.
 *
 * Extracted from the prototype `compass-intake.jsx:74` (the `Avatar` / `.cs-av` class).
 * 30×30 navy rounded square with the Elion "E" logomark (white SVG).
 */

import { ElionE } from "../lib/icons";

export interface AvatarProps {
  /** Accessible title for the avatar. */
  title?: string;
  /** Image source for the monogram. Falls back to the `ElionE` glyph from icons. */
  imgSrc?: string;
}

/**
 * Compact brand avatar used beside AI-generated messages.
 *
 * `.cs-av` → 30×30, `bg-brand-navy`, `rounded-[--radius-full]`
 */
export function Avatar({ title = "Compass", imgSrc }: AvatarProps) {
  return (
    <div
      className={[
        "flex-shrink-0",
        "w-[30px] h-[30px]",
        "rounded-full",
        "bg-(--brand-navy)",
        "text-white",
        "flex items-center justify-center",
      ].join(" ")}
      title={title}
      role="img"
      aria-label={title}
    >
      {imgSrc ? (
        <img
          src={imgSrc}
          alt="Elion"
          className="w-[17px] h-[17px] brightness-0 invert"
        />
      ) : (
        <ElionE size={16} />
      )}
    </div>
  );
}
